import { hamburger, close } from "@/assets/images/index";
import { useDesignMaxTheme } from "@/packages";
import { Box, Center, chakra, Flex } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { useNewNavigate, useToggleValue } from "@shared/client";
import { useEffect, useRef, useState } from "react";
import { DetailMenuBar, ToggleMenu } from "./components";
import { type HeaderProps } from "./types";

export const Header = ({ logoUrl, navigation }: HeaderProps) => {
    const headerRef = useRef<HTMLElement>(null);

    const [isFixed, setIsFixed] = useState(false);
    const [hasScrolled, setHasScrolled] = useState(false);

    const isMenu = useToggleValue();
    const { isMobile, isLaptop } = useDesignMaxTheme().MEDIAS();
    const { onNavigate } = useNewNavigate();

    useEffect(() => {
        const scrollRoot = document.getElementById("scrollRoot");
        if (!scrollRoot || !headerRef.current) {
            return undefined;
        }

        const headerHeight = headerRef.current.offsetHeight;

        const onScroll = () => {
            const { scrollTop } = scrollRoot;

            setHasScrolled(scrollTop > 0);

            if (isMobile) {
                setIsFixed(scrollTop >= headerHeight);
            }
        };

        scrollRoot.addEventListener("scroll", onScroll);

        return () => {
            scrollRoot.removeEventListener("scroll", onScroll);
        };
    }, [isMobile]);
    // useEffect(() => {
    //     const scrollRoot = document.getElementById("scrollRoot");
    //     if (!scrollRoot || !headerRef.current) return undefined;

    //     const headerHeight = headerRef.current.offsetHeight;

    //     const onScroll = () => {
    //         const scrollTop = scrollRoot.scrollTop;

    //         setHasScrolled(scrollTop > 0);

    //         // 📱 모바일: 헤더 높이 지나면 fixed
    //         if (isMobile) {
    //             setIsFixed(scrollTop >= headerHeight);
    //         }
    //     };

    //     scrollRoot.addEventListener("scroll", onScroll);
    //     return () => scrollRoot.removeEventListener("scroll", onScroll);
    // }, [isMobile]);

    return (
        <>
            {/* 📱 모바일 fixed 전환 시 레이아웃 밀림 방지 */}
            {isMobile && isFixed && <Box h={isLaptop ? "60px" : "88px"} />}

            <S.Wrapper
                ref={headerRef}
                data-fixed={!isMobile || isFixed}
                data-scrolled={hasScrolled}
                data-mobile={isMobile}
                h={isLaptop ? "60px" : "88px"}
                sx={{
                    _hover: {
                        "& .hamburger_menu": {
                            background: !isMenu
                                ? `url(${hamburger}) no-repeat center/cover`
                                : `url(${close}) no-repeat center/cover`,
                        },
                    },
                }}
            >
                <Center maxW="1600px" w="100%" p="0 24px" justifyContent="space-between">
                    <Flex flex="1" justifyContent="space-between" alignItems="center">
                        {/* <Box
                            bg={`url(${logoUrl}) no-repeat center/cover`}
                            w={isMobile ? "110px" : "200px"}
                            h={isMobile ? "32px" : "60px"}
                            cursor="pointer"
                            onClick={() => {
                                onNavigate({ path: "/home" });
                                document.getElementById("scrollRoot")?.scrollTo({ top: 0, behavior: "smooth" });
                            }}
                        /> */}
                        <Box
                            className="logo"
                            bg={`url(${logoUrl}) no-repeat center/cover`}
                            w={isMobile ? "110px" : "200px"}
                            h={isMobile ? "32px" : "60px"}
                            cursor="pointer"
                            onClick={() => {
                                onNavigate({ path: "/home" });
                                document.getElementById("scrollRoot")?.scrollTo({ top: 0, behavior: "smooth" });
                            }}
                        />
                        <ToggleMenu>
                            <DetailMenuBar navigation={navigation} />
                        </ToggleMenu>
                    </Flex>
                </Center>
            </S.Wrapper>
        </>
    );
};
const Wrapper = styled(chakra.header)`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    z-index: 9995;
    transition: background 0.3s ease;

    position: relative;
    background: transparent;

    &[data-fixed="true"][data-mobile="false"],
    &[data-fixed="true"][data-mobile="true"] {
        position: fixed;
        top: 0;
        left: 0;
    }

    /* 🔥 스크롤 시 로고 흰색 */
    &[data-scrolled="true"] .logo {
        filter: brightness(0) invert(1);
    }

    /* 📱 모바일은 기본 흰색 */
    &[data-mobile="true"] .logo {
        filter: brightness(0) invert(1);
    }

    /* 부드럽게 */
    .logo {
        transition: filter 0.3s ease;
    }

    /* hover 시도 흰색 */
    &:hover .logo {
        filter: brightness(0) invert(1);
    }

    &[data-scrolled="true"][data-mobile="false"] {
        background: rgba(0, 0, 0, 0.4);
    }

    &[data-mobile="true"] {
        background: rgba(0, 0, 0, 0.4);
    }
`;
// const Wrapper = styled(chakra.header)`
//     width: 100%;
//     display: flex;
//     align-items: center;
//     justify-content: center;

//     z-index: 9995;
//     transition: background 0.3s ease;

//     /* 기본 */
//     position: relative;
//     background: transparent;

//     /* PC는 무조건 fixed */
//     &[data-fixed="true"][data-mobile="false"] {
//         position: fixed;
//         top: 0;
//         left: 0;
//     }

//     /* 📱 모바일 fixed 전환 */
//     &[data-fixed="true"][data-mobile="true"] {
//         position: fixed;
//         top: 0;
//         left: 0;
//     }

//     /* 🖥 PC 스크롤 시 배경 */
//     &[data-scrolled="true"][data-mobile="false"] {
//         background: rgba(0, 0, 0, 0.4);
//     }

//     /* 📱 모바일 기본 배경 */
//     &[data-mobile="true"] {
//         background: rgba(0, 0, 0, 0.4);
//     }

//     &:hover {
//         background: rgba(0, 0, 0, 0.4);

//         & svg {
//             color: white !important;
//         }
//     }
// `;

const S = { Wrapper };
